export default {
	about: 'About us',
	mission: 'Mission',
	vision: 'Our Vision',
	policy: 'Privacy agreement',
	qualityPolicy: 'Quality policy'
}